import UserProfile from './component'
import { connect } from 'react-redux'

const mapStateToProps = ({appConfig: {mancalaUrl}}) => ({mancalaUrl})

export default connect(mapStateToProps)(UserProfile)
